export default __webpack_public_path__ + "static/media/frenchfries@3x.cf6c53a6.jpg";